module.exports = __webpack_public_path__ + "static/media/user.47cdf934.svg";